<form
  [id]="formId"
  [formGroup]="cipherForm"
  [bitSubmit]="submit"
  class="bv-vault-cipher-form__body"
  [class.bv-vault-cipher-form--secure-note]="config.cipherType === CipherType.SecureNote"
  [class.bv-vault-cipher-form--identity]="config.cipherType === CipherType.Identity"
  [class.bv-vault-cipher-form--card]="config.cipherType === CipherType.Card"
>
  @if (!loading) {
    <div class="bv-cipher-type-field">
      <bit-form-field disableMargin>
        <bit-label>{{ "whatTypeOfItem" | i18n }}</bit-label>
        @if (canChangeCipherType) {
          <bit-select
            [ngModel]="config.cipherType"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="changeCipherType($event)"
          >
            @for (item of availableCipherTypes; track item.type) {
              <bit-option [value]="item.type" [label]="item.labelKey | i18n"></bit-option>
            }
          </bit-select>
        } @else {
          <input
            bitInput
            readonly
            tabindex="-1"
            aria-readonly="true"
            [value]="cipherTypeLabel"
            class="bv-cipher-type-field__value"
          />
        }
      </bit-form-field>
    </div>

    <vault-new-item-nudge [configType]="config.cipherType"> </vault-new-item-nudge>

    <vault-item-details-section
      [config]="config"
      [originalCipherView]="originalCipherView"
    ></vault-item-details-section>

    @if (config.cipherType === CipherType.Login) {
      <vault-login-details-section></vault-login-details-section>
    }

    @if (config.cipherType === CipherType.Identity) {
      <vault-identity-section
        [disabled]="config.mode === 'partial-edit'"
        [originalCipherView]="originalCipherView"
      ></vault-identity-section>
    }

    @if (config.cipherType === CipherType.Card) {
      <vault-card-details-section
        [originalCipherView]="originalCipherView"
        [disabled]="config.mode === 'partial-edit'"
      ></vault-card-details-section>
    }

    @if (config.cipherType === CipherType.SshKey) {
      <vault-sshkey-section [originalCipherView]="originalCipherView"></vault-sshkey-section>
    }

    @if (config.cipherType === CipherType.BankAccount) {
      <vault-bank-account-section
        [disabled]="config.mode === 'partial-edit'"
        [originalCipherView]="originalCipherView"
      ></vault-bank-account-section>
    }

    @if (config.cipherType === CipherType.DriversLicense) {
      <vault-drivers-license-section
        [disabled]="config.mode === 'partial-edit'"
        [originalCipherView]="originalCipherView"
      ></vault-drivers-license-section>
    }

    @if (config.cipherType === CipherType.Passport) {
      <vault-passport-section
        [disabled]="config.mode === 'partial-edit'"
        [originalCipherView]="originalCipherView"
      ></vault-passport-section>
    }

    <vault-additional-options-section
      [disableSectionMargin]="config.mode !== 'edit'"
    ></vault-additional-options-section>

    @if (config.mode == "edit") {
      <ng-content select="[slot=attachment-button]"></ng-content>
    }
  }
</form>
